import React from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {resetModal} from "../../state/actions/modalAction";
import alertIcon from "../../assets/images/error-icon.png";
import DepositPopUpComponentProps from "./DepositPopUpComponentProps";
import './DepositPopUpComponent.scss'
import {useHistory} from "react-router-dom";

const DepositPopUpComponent = (props: DepositPopUpComponentProps) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const {t} = useTranslation("common");
    const closeModal = () => {
        dispatch(resetModal());
    };
    const msg = () => {
        if ((props.isFromupdateBankAccount == true) &&
            props.interactiveFormPath.errorCode !== 0) {
            // setShowContactMsg(true);
            return t('Sidebar.updateBankAccountError')
        } else if ((props.interactiveFormPath.errorCode === 0 && props.interactiveFormPath.interactiveFormPath == null) ||
            props.interactiveFormPath.errorCode === 99) {
            // setShowContactMsg(true);
            return t('depositPopUp.error99')
        } else if (props.interactiveFormPath.errorCode === 85401)
            return t('depositPopUp.error85401')
        else if (props.interactiveFormPath.errorCode === 85402)
            return t('depositPopUp.error85402')
        else if (props.interactiveFormPath.errorCode === 85403)
          return t("depositPopUp.error85403");
        else if (props.interactiveFormPath.errorCode === 85404)
          return t("depositPopUp.error85404");
        else if (props.interactiveFormPath.errorCode === 85405)
          return t("depositPopUp.error85405");
        else if (props.interactiveFormPath.errorCode === 600071)
          return t("depositPopUp.error600071");
        else {
          // setShowContactMsg(true);
          return t("depositPopUp.error99");
        }
    }
    return (
        <div className="deposit-container">
            <img src={alertIcon} alt="alert"/>
            <span className="deposit-failed-label">
                {msg()}
                {
                    props.interactiveFormPath.errorCode !== 85401 && props.interactiveFormPath.errorCode !== 85402 && props.interactiveFormPath.errorCode !== 85403 && props.interactiveFormPath.errorCode !== 85404 && props.interactiveFormPath.errorCode !== 85405 ?
                        <div>
                            <a style={{color: "blue", textDecoration: "underline"}} onClick={() => {
                                history.push('contact');
                                dispatch(resetModal());
                            }}>{t('depositPopUp.contact')}</a>
                        </div> : ""
                }
      </span>
            {/* <span className="otp-error-try-again">{t("idle.subLabel")}</span> */}
            <div className="btn-group">
                <button className="disconnect-btn" onClick={closeModal}>
                    {t("depositPopUp.close")}
                </button>
            </div>
        </div>
    );
}
export default DepositPopUpComponent;